import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Landing from '../components/landing';
import * as CoreActions from '../actions/coreActions';
import * as store from '../../api/localStore';
import { PORTAL_FEATURE } from '../constants/coreConstants';
import { browserHistory } from 'react-router';
import Controls from '../../util/controls';

class CorePage extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(function () {
      let token = store.get('token');
      if (!token) {
        browserHistory.push('/auth?mode=login');
      }
    }.bind(this), 30);
  }

  render() {
    if (this.props.core.featuresLoaded == false) {
      return (
        <Controls.LoadingPanel />
      );
    }
    return (
      <div className="Core">
        {this.props.auth.loggedIn && this.props.core.features[PORTAL_FEATURE] && <Landing {...this.props} />}
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    core: state.core,
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(CoreActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(CorePage);



// WEBPACK FOOTER //
// ./app/core/containers/corePage.js